import React, { useState } from 'react'
import PanelGroup from 'react-bootstrap/lib/PanelGroup'
import Panel from 'react-bootstrap/lib/Panel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import FutworkButton from '../../../../uicomponents/button/Button'
import SnapshotForm from './SnapshotForm'

/*
 * Read-only counterpart to Editor.jsx, using the builder's own markup -
 * crud-form, header-section, border-outline, PanelGroup/Panel - so it reads as
 * the same sheet. Everything that writes is gone: the heading Select, the
 * "Mark as initial" checkbox, "Create new label", the textareas and SUBMIT.
 *
 * Data Collection Form and Trigger Action keep their buttons, because that is
 * how the builder reveals them; they open the same popups in read-only form.
 */

const SnapshotDetail = ({ selection, scripts, onClose }) => {
    const [popup, setPopup] = useState(null)

    if (!selection) return null

    const { kind, payload } = selection
    const data = (payload && payload.data) || {}
    const isNode = kind !== 'edge'

    //The same id exists in every language, so each language's copy of this node
    //or edge can be listed the way the builder lists them.
    const perLanguage = (scripts || []).map(script => ({
        name: script.scriptLanguage,
        element: (script.script || []).find(element => element.id === payload.id)
    })).filter(entry => entry.element)

    return (
        <div className="crud-form snapshot-readonly">
            <div className='header-section'>
                <span className='heading'>{isNode ? 'Node' : 'Edge'}</span>
                <FontAwesomeIcon icon={faXmark} className='close-icon' onClick={onClose} />
            </div>

            {isNode ?
                <div className='border-outline'>
                    <div className="title">Title</div>
                    <div style={{ margin: '1.1rem 1.5rem' }}>
                        <Select options={[]} className="outcome-config" classNamePrefix="select"
                            value={{ value: data.heading, label: data.heading }}
                            isDisabled={true} isSearchable={false} />
                    </div>
                    <label style={{ padding: '0 0 0 3.5%' }}>
                        <input type="checkbox" checked={!!(perLanguage[0] && perLanguage[0].element && perLanguage[0].element.initialNode)} disabled readOnly />
                        <span>Mark {data.heading} as initial</span>
                    </label>
                </div>
                : (data.outcome ?
                    <div className='border-outline'>
                        <div className="title">Outcome</div>
                        <div style={{ margin: '1.1rem 1.5rem' }}>
                            <Select options={[]} className="outcome-config" classNamePrefix="select"
                                value={{ value: data.outcome, label: data.outcome }}
                                isDisabled={true} isSearchable={false} />
                        </div>
                    </div> : null)}

            <div className="in-form">
                <div className='border-outline'>
                    <PanelGroup accordion id="snapshot-accordion">
                        {perLanguage.map((lang, i) => (
                            <Panel eventKey={i + 1} key={i + 1}>
                                <Panel.Heading>
                                    <Panel.Title toggle>
                                        <div className="title"> {isNode ? 'Text' : 'Edge'} ({lang.name})</div>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    {isNode ? <>
                                        <textarea rows="4" style={{ width: '100%' }} disabled readOnly
                                            value={(lang.element.data && lang.element.data.label) || ''} />
                                        {lang.element.data && lang.element.data.callerCueText ?
                                            <>
                                                <div>Caller cue</div>
                                                <textarea style={{ width: '100%' }} disabled readOnly
                                                    value={lang.element.data.callerCueText} />
                                            </> : null}
                                    </> : <>
                                        <div>Label</div>
                                        <textarea style={{ width: '100%' }} disabled readOnly
                                            value={lang.element.label || ''} />
                                    </>}
                                </Panel.Body>
                            </Panel>
                        ))}
                    </PanelGroup>
                </div>

                {isNode && ((data.form && data.form.length > 0) || (data.actions && data.actions.length > 0)) ?
                    <div className='border-outline'>
                        <div className="title">Actions</div>
                        {data.form && data.form.length > 0 ?
                            <FutworkButton buttonSize='medium w-100'
                                onClick={() => setPopup('form')}>
                                Data Collection Form
                            </FutworkButton> : null}
                        {data.actions && data.actions.length > 0 ?
                            <FutworkButton buttonSize='medium w-100' buttonStyle='gradient-1--solid'
                                onClick={() => setPopup('trigger')}>
                                <img src={require('../../../../assets/images/Icons_IS_trigger_white.svg')} /> Trigger Action
                            </FutworkButton> : null}
                    </div> : null}

                {/* {data.audio ? <div className='snapshot-audio-note'>Audio attached</div> : null} */}
            </div>

            {popup ?
                <SnapshotForm
                    kind={popup}
                    nodeId={payload.id}
                    scripts={scripts}
                    closePopup={() => setPopup(null)}
                /> : null}
        </div>
    )
}

export default SnapshotDetail
